<template>
  <div class="kanban-login" :class="disappear === 1 ? 'puffOut' : ''">
      <div>
            <img :src="getImgUrl(qrImgUrl)" alt="">
            <div v-if="tip === 1" style="color: rgba(51, 51, 51, 1);text-align: center;font-size:18px;">请用<span style="color: rgba(26, 179, 148, 1);">APP扫码</span>操作</div>
            <div v-if="tip === 2">
                <div style="color: rgba(234, 67, 53, 1);text-align: center;">扫描失败！</div>
                <div style="color: rgba(51, 51, 51, 1);text-align: center;">请重新用APP扫码操作</div>
            </div>
      </div>
  </div>
</template>

<script>

export default {
  data() {
    return{
        userId: '', // 用户唯一标识码
        websocketServer: '', // websocketServer
        qrImgUrl: '', // 图片路径
        kanbanId: null, // 看板id
        tip: 1, // 提示文字
        disappear: 0,
    }
  },
  created() {
      this.$nextTick(() => {
          // 设置标题名称
          document.title = '看板登录'
          // 获取当前看板登录信息
          this.getkanbanInfo().then(() => {
              // 连接WebSocket
              this.WebSocketTest()
          })
          
                   
      })
      
  },
  mounted() {
    
  },
  methods: {
        // 获取当前看板登录信息
        async getkanbanInfo() {
            let res = await this.$axios.get('https://kclass.krcedu.com:82/kclass/REST/getPadScanQR?action=kanban&imgSize=314')
            if(res.status === 200) {
                this.userId = res.data.userId
                this.websocketServer = res.data.websocketServer
                this.qrImgUrl = res.data.qrImgUrl
            }
        },
        // 获取图片路径
        getImgUrl(imgUrl) {
            return `https://kclass.krcedu.com:82/kclass/${imgUrl}`
        },
        // 连接WebSocket
        WebSocketTest(){
            let self = this
            if ("WebSocket" in window) {

                // // 打开一个 web socket
                let websocket = null;
                if ('WebSocket' in window) { 
                    websocket = new WebSocket(`${this.websocketServer}/${this.userId}`); 
                } 

                //连接发生错误的回调方法 
                websocket.onerror = function(event) { 
                    console.log("连接发生错误" + event)
                    window.location.reload()
                    this.tip = 2
                };  

                //连接成功建立的回调方法 
                websocket.onopen = function(e) {
                    // console.log(e);
                    console.log("连接成功")
                } 

                //接收到消息的回调方法 
                websocket.onmessage = function(event) {
                    console.log("后台推送的消息：" + event.data);
                    if(event.data) {
                        this.kanbanId = event.data
                        console.log('获取到了' + this.kanbanId)
                        self.goKanban(event.data)
                    }
                　　 websocket.close();
                }

                //连接关闭的回调方法 
                websocket.onclose = function() {
                    console.log("WebSocket连接关闭");
                }

                //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
                window.onbeforeunload = function() {
                    // 关闭连接
                    this.closeWebSocket(websocket);
                }

            } else {
                // 浏览器不支持 WebSocket
                alert("您的浏览器不支持 WebSocket!");
            }
        },
        //关闭WebSocket连接 
        closeWebSocket(value) { 
            value.close(); 
        },
        // 跳转对应看板页面
        goKanban(kanbanId) {
            if(kanbanId !== null) {
                this.disappear = 1
                console.log(this.disappear)
                this.timer = setTimeout(() => {
                    this.$router.push({path: `/Kanban/${kanbanId}`})
                }, 1000)               
            }
        }
    }
}
</script>

<style scoped>
.puffOut {
    -webkit-animation-name:puffOut;
    animation: puffOut 1s;
}
@keyframes puffOut {
    /* 0%{opacity:1;transform-origin:50% 50%;transform:scale(2,2);} */
    /* 0%{opacity:0;transform-origin:50% 50%;transform:scale(2,2);} */
    0%{opacity:1;transform-origin:50% 50%;transform:scale(1,1);filter: blur(0px);-webkit-filter:blur(0px);}
    100%{opacity:0;transform-origin:50% 50%;transform:scale(2,2);filter: blur(2px);-webkit-filter:blur(2px);}
}
.kanban-login {
    /* width: 100vw; */
    min-width: 1920px;
    /* height: 100vh; */
    min-height: 1001px;
    background: url(../assets/images/QRcodebg.png) center center no-repeat;
    background-size: 100% 100%;
    color: aquamarine;
}
.kanban-login-disappear {
    /* animation: disappear 1s;
    animation-fill-mode: forwards; */
}
@keyframes disappear {
    /* from {opacity: 1;}
    to {opacity: 0;} */
}
img {
    display: block;
    margin: 0 auto;
    padding-top: 270px;
    width: 345px;
}
</style>
